"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResetForm = void 0;
const getResetForm = () => {
    return {
        submitCount: 0,
        isSubmitted: false,
        isDirty: false,
        isValid: false,
        isLoading: false,
        isSubmitting: false,
    };
};
exports.getResetForm = getResetForm;
//# sourceMappingURL=getResetForm.js.map